module.exports = __webpack_public_path__ + "static/media/ContactRight_ID.11c48b25.png";